<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" sm="4">
                <h1 class="headline font-weight-light mb-3">
                    {{ project }}
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="8" class="text-right"
                ><v-btn
                    class="ma-2"
                    tile
                    color="success"
                    @click="export_data()"
                >
                    <v-progress-linear
                        v-if="chk_export == true"
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>

                    <span v-if="chk_export == false" left>
                        <v-icon class="mr-2">mdi-file-excel</v-icon>Export</span
                    >
                </v-btn>
                <v-btn
                    @click="dialog = true"
                    class="ma-2"
                    tile
                    outlined
                    color="success"
                >
                    <v-icon left>mdi-plus</v-icon>Add New
                </v-btn>

                <v-btn
                    @click="dialog2 = true"
                    class="ma-2"
                    outlined
                    tile
                    color="info"
                >
                    <v-icon left>mdi-plus</v-icon>Edit
                </v-btn>
                <v-btn
                    @click="dialog3 = true"
                    class="ma-2"
                    outlined
                    tile
                    color="amber"
                    v-if="team_name == 'NONHP'"
                >
                    Close Outsource Case
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col
                v-for="(row, index) in data_main"
                :key="index"
                cols="12"
                sm="4"
                md="3"
            >
                <v-card
                    :color="row.group_id === chk_btn ? 'teal accent-1' : ''"
                    @click="get_branch(row.group_id)"
                >
                    <!-- @click="getDetail(row.group_id)" -->

                    <v-list-item two-line>
                        <v-list-item-content>
                            <b>{{ row.project_name }}</b>
                        </v-list-item-content>
                        <v-btn fab dark small color="teal accent-3">{{
                            row.num_cases
                        }}</v-btn>
                    </v-list-item>
                </v-card>
                <!-- <router-link
                        class="link-a"
                        :to="
                            '/Project/PmInstall/Dashboard/' +
                                project +
                                '/' +
                                item.project +
                                '/' +
                                item.text
                        "
                    >
                        <stat-card
                            v-on:onClick="selectCard(item.text)"
                            :color="item.color"
                            :icon="item.icon"
                            :title="item.project"
                            :smallValue="item.num"
                            sub-icon="mdi-clock"
                            :sub-text="item.period"
                        />
                    </router-link> -->
            </v-col>
        </v-row>

        <v-card class="mt-4">
            <v-card-title>
                <v-row>
                    <!-- <v-col cols="12" sm="6" md="4">
                        <v-select
                            class="mr-2"
                            :items="status"
                            v-model="form.status"
                            item-text="main_status_name"
                            item-value="main_status_id"
                            label="Select Status"
                            multiple
                            clearable
                            @blur="test()"
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 2">
                                    <span>{{ item.main_status_name }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 2"
                                    class="grey--text caption"
                                >
                                    (+{{ form.status.length - 2 }}
                                    others)
                                </span>
                            </template>
                        </v-select>
                    </v-col> -->

                    <!-- <v-col cols="12" sm="5" md="4">
                        <v-text-field
                            v-model="form.searchtext"
                            append-icon="mdi-magnify"
                            label="Search"
                            clearable
                            @input="
                                pagination.current = 1
                                getDetail()
                            "
                        ></v-text-field>
                    </v-col> -->
                </v-row>
            </v-card-title>
            <div class="pa-4">
                <v-row class="mar-t-30">
                    <v-col cols="5" md="3">
                        <v-autocomplete
                            dense
                            outlined
                            :items="data_branch"
                            item-text="branch_name"
                            item-value="branch_id"
                            label="Branch"
                            menu-props="auto"
                            required
                            hide-details
                            v-model="search.branch_id"
                            @change="get_status_filter()"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="5" md="3">
                        <v-autocomplete
                            dense
                            outlined
                            label="Status"
                            required
                            :items="data_status_filter"
                            item-text="main_status_name"
                            item-value="main_status_id"
                            v-model="search.main_status_id"
                            @change="getDetail(chk_btn)"
                        >
                            <template slot="item" slot-scope="data">
                                {{ data.item.main_status_name }}
                                <v-chip
                                    small
                                    class="ml-1"
                                    color="blue lighten-3"
                                    >{{ data.item.num_cases }}</v-chip
                                >
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="1">
                        <v-btn
                            x-small
                            fab
                            class="mt-1"
                            v-if="
                                search.branch_id != '' ||
                                    search.main_status_id != ''
                            "
                            @click="reset()"
                        >
                            <v-icon>mdi-rotate-left</v-icon></v-btn
                        >
                    </v-col>
                </v-row>
            </div>

            <table-view-case
                class="mar-t-30"
                :condition="condition"
                :data_case="data_case"
                :casetab="casetab"
            />
            <div class="text-center pa-5">
                <v-pagination
                    @input="onPageChange"
                    v-model="pagination.current"
                    :length="data_case.last_page"
                    total-visible="10"
                    circle
                ></v-pagination>
            </div>
        </v-card>

        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">Add {{ project }} Project</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="dowload_file(1)"
                        class="ma-2"
                        tile
                        color="info"
                        outlined
                    >
                        <v-icon left>mdi-file-excel</v-icon>dowload template add
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                    v-model="data_main.project_id"
                                    :items="selectproject"
                                    item-text="project_name"
                                    item-value="project_id"
                                    label="Project"
                                ></v-select>
                            </v-col>
                            <!-- <v-col cols="8" sm="6" md="3">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      label="Date Period"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    @change="dateRangeText.length === 23 ? (menu2 = false) : ''"
                    v-model="dates"
                    range
                  ></v-date-picker>
                </v-menu>
              </v-col> -->
                            <v-col cols="12" sm="6" md="4">
                                <v-file-input
                                    v-model="files"
                                    color="blue darken-4"
                                    counter
                                    label="อัพโหลดงาน PM & Install"
                                    multiple
                                    small-chips
                                    placeholder="Select your files"
                                    prepend-icon="mdi-paperclip"
                                    :show-size="1000"
                                ></v-file-input>
                            </v-col>
                            <!-- <v-col cols="12" sm="6" md="4">
                <v-switch label="Status"></v-switch>
              </v-col> -->
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog2" max-width="700">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit {{ project }} Project</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="dowload_file(2)"
                        class="ma-2"
                        tile
                        color="info"
                        outlined
                    >
                        <v-icon left>mdi-file-excel</v-icon>dowload template add
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-file-input
                                    v-model="files"
                                    color="blue darken-4"
                                    counter
                                    label="อัพโหลดงาน PM & Install"
                                    multiple
                                    small-chips
                                    placeholder="Select your files edit"
                                    prepend-icon="mdi-paperclip"
                                    :show-size="1000"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog2 = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save_edit()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog3" max-width="500">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        {{ project }} Close Outsource Case
                    </span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    outlined
                                    v-model="form_outsource"
                                    label="Case ID.."
                                    rows="6"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close_outsource()"
                        >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save_outsource()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import StatsCard from "../../../components/StatsCard"
import MeterialCard from "../../../components/MaterialCard"
import readXlsxFile from "read-excel-file"
import TableViewCase from "../components/TableViewCase"
import { mapState, mapMutations } from "vuex"

let urls = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        "stat-card": StatsCard,
        "base-material-card": MeterialCard,
        TableViewCase,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.getData()
        this.getProject()
    },
    watch: {
        "$route.params.project": function(val) {
            this.project = this.$route.params.project
            this.getData()
            this.getProject()
            this.data_case = []

            this.pagination.current = 1

            this.search.branch_id = ""
            this.search.main_status_id = ""
            this.data_branch = []
            this.data_status_filter = []
        },
    },
    computed: {
        dateRangeText() {
            this.data.period = [...this.dates]
            this.dates.sort((a, b) => {
                return new Date(a) - new Date(b)
            })
            return this.dates.join(" ~ ")
        },
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },

    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async getData() {
            await axios
                .get(
                    urls + "summary-project/" + this.$route.params.project,
                    this.tk
                )
                .then((response) => {
                    this.data_main = response.data
                    this.active_card = response.data[0]
                    this.chk_btn = response.data[0].group_id
                    this.get_branch()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_branch(datax) {
            if (datax != undefined) {
                this.chk_btn = datax
            }
            await axios
                .get(urls + "get-filter-branch/" + this.chk_btn, this.tk)
                .then((response) => {
                    this.data_branch = response.data
                    this.get_status_filter()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_status_filter() {
            let send = {
                group_id: this.chk_btn,
                branch_id: this.search.branch_id,
            }
            await axios
                .post(urls + "get-filter-status", send, this.tk)
                .then((response) => {
                    this.data_status_filter = response.data
                    this.getDetail(this.chk_btn)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getDetail()
        },
        async getDetail(group_id) {
            this.casetab = false
            if (group_id) {
                this.chk_btn = group_id
            }
            let send = {
                group_id: this.chk_btn,
                branch_id: this.search.branch_id,
                main_status_id: this.search.main_status_id,
            }
            await axios
                .post(
                    urls +
                        "view-all-case/" +
                        this.$route.params.project +
                        "?page=" +
                        this.pagination.current,
                    send,
                    this.tk
                )
                .then((response) => {
                    this.pagination.current = response.data.current_page
                    this.data_case = response.data
                    this.casetab = true
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        reset() {
            this.search.branch_id = ""
            this.search.main_status_id = ""

            this.getDetail()
        },
        async save() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }

            try {
                this.mutateIsLoading()
                let formData = new FormData()
                const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/create-new`
                for (let i = 0; i < this.files.length; i++) {
                    formData.append(`files`, this.files[i])
                }

                // formData.append(`period`, this.dates)
                formData.append(`project_id`, this.data_main.project_id)
                // formData.append(`status`, "Active")
                formData.append(`type`, this.$route.params.project)

                const { data, status } = await axios.post(
                    url,
                    formData,
                    options
                )
                this.getData()
                this.dialog = false
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async save_edit() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }

            try {
                this.mutateIsLoading()
                let formData = new FormData()
                const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/save-edit`
                for (let i = 0; i < this.files.length; i++) {
                    formData.append(`files`, this.files[i])
                }

                // formData.append(`period`, this.dates)
                // formData.append(`project_id`, this.data_main.project_id)
                // formData.append(`status`, "Active")
                // formData.append(`type`, this.$route.params.project)
                // q test
                const { data, status } = await axios.post(
                    url,
                    formData,
                    options
                )
                this.dialog2 = false
                this.getData()

                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async getProject() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/project-list/${this.$route.params.project}`
            try {
                const { data } = await axios.get(`${url}`, this.tk)
                this.selectproject = data
            } catch (error) {
                console.log(error)
            }
        },

        dowload_file(st) {
            let url_dowload
            if (st == 1) {
                url_dowload = `${process.env.VUE_APP_ROOT_API}/api/nonhp/download/template`
            } else if (st == 2) {
                url_dowload = `${process.env.VUE_APP_ROOT_API}/api/nonhp/download/edit-template`
            }
            axios({
                url: url_dowload,
                method: "GET",
                responseType: "blob",
            }).then((response) => {
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        export_data() {
            this.chk_export = true
            axios({
                url:
                    `${process.env.VUE_APP_ROOT_API}/api/export-pending/` +
                    this.chk_btn,
                method: "GET",
                responseType: "blob",
            }).then((response) => {
                this.chk_export = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        close_outsource() {
            this.form_outsource = ""
            this.dialog3 = false
        },
        async save_outsource() {
            let send = {
                case: this.form_outsource,
            }
            await axios
                .post(urls + "nonhp/save-close-case", send, this.tk)
                .then((response) => {
                    this.mutatesnackbar()
                    this.close_outsource()
                    this.getData()
                    this.getProject()

                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            form_outsource: "",
            dialog3: false,
            dialog2: false,
            chk_export: false,
            data_status_filter: [],
            data_branch: [],
            casetab: false,
            data_main: [],
            active_card: [],
            tk: null,
            chk_btn: null,
            group_id: 0,
            //qqq
            files: [],
            dates: [],
            project: this.$route.params.project,
            data: {},
            arr_card: [],
            dialog: false,
            information: [],
            selectproject: [],
            menu2: false,
            condition: {
                team: "Nonhp",
                status: "ViewDetail",
            },
            data_case: [],
            pagination: {
                current: 1,
            },
            status: [],
            form: {
                projects: [],
                status: [],
                searchtext: "",
            },
            search: {
                branch_id: "",
                main_status_id: "",
            },
            team_name: localStorage.team_name,
            text: "Success, Your work has been saved",
        }
    },
}
</script>
